<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InspectionResultSummaryForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InspectionResultSummaryForm from '@/components/organisms/report/form/InspectionResultSummaryForm'

export default {
  name: 'InspResultSummaryPage',
  components: { InspectionResultSummaryForm },
}
</script>
